import { getUploadStatusInfo } from "../../utils/uploadStatus";

interface UploadStatusBadgeProps {
  status: string | null | undefined;
}

const UploadStatusBadge = ({ status }: UploadStatusBadgeProps) => {
  const info = getUploadStatusInfo(status);

  return (
    <span
      className={`inline-block px-2 py-0.5 rounded-full text-[11px] font-medium whitespace-nowrap ${info.badgeClass}`}
    >
      {info.label}
    </span>
  );
};

export default UploadStatusBadge;
